<script>
/**
 * @overview 全局选择文件组件
 *
 * @author huojinzhao
 */
import { Message } from "element-ui";
import * as globalServer from '../../api/global';

export default {
  name: "AppFile",

  props: {
    types: {
      type: String,
      default: "",
    },
    url: {
      type: String,
      default: "",
    },
    isAdd: {
      type: Boolean,
      default: false,
    },
    // 是否自己处理，如果自己处理直接return方法
    isSelf: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      randomID: Math.floor(Math.random() * (10 ** 10)),
      newOffsetTop: this.offsetTop,
    };
  },
  computed: {
    inputID() {
      return `app-create-file__input-${this.randomID}`;
    },

    fileTypes() {
      return this.types
        .split(",")
        .map(type => `.${type.trim()}`)
        .filter(type => type);
    },

    fileTypeErrorMessage() {
      return `文件类型错误，仅支持${this.fileTypes.toString()}类型格式的文件`;
    },
  },
  watch: {
    offsetTop(vl) { this.newOffsetTop = vl; },
    newOffsetTop(vl) { this.$emit('update:offsetTop', vl); },
  },

  methods: {
    async fileChoose({ target: { files } }) {
      console.log(111);

      // 判断当前文件是不是存在空格
      if (files && files[0].name && files[0].name.indexOf(' ') !== -1) {
        this.$refs.input.value = null;
        Message.error("上传文件名不允许出现空格！");
        return false;
      }
      // 判断当前文件是不是已经存在
      if (this.isAdd && files && files[0].name) {
        try {
          const res = await globalServer.isHasFile({ name: files[0].name });
          if (res[0].id) {
            this.$refs.input.value = null;
            Message.error("上传文件名已存在请重新上传！");
            return false;
          }
        } catch (e) {
          console.log('err==>', e);
        }
      }
      // 如果是动画包小于 50kb的话表示这个包是错的
      if (files && files[0].type && files[0].type.indexOf('zip') !== -1 && files[0].size < 100) {
        Message.error("您上传的文件包错误，请上传正确的文件包。");
        return false;
      }
      const fileList = Array.from(files);

      this.$refs.input.value = null;

      // 只有上传一样的文件名称才能替换
      if (!this.isAdd) {
        let name = "";
        if (this.url && typeof this.url === "string") {
          const arr = this.url.split("/");
          name = arr[arr.length - 1];
          if (name.indexOf('?') > -1) {
            name = name.split('?')[0];
          }
        }
        console.log('name', name, fileList[0].name);
        if (name && name !== fileList[0].name) {
          Message.error("上传文件名必须是一样的才能替换");
          return false;
        }
      }

      fileList.length
        && this.isFileTypeProper(fileList)
        && this.$emit("success", fileList);
    },

    isFileTypeProper(files) {
      if (!this.types) return true;

      const isProper = files
        .every(file => this.fileTypes.some(type => file.name.endsWith(type)));

      !isProper
        && this.$emit("error", this.fileTypeErrorMessage);

      return isProper;
    },
    onSelf() {
      if (this.isSelf) {
        this.$emit('onSelf', this.types);
        return false;
      }
    },
  },
};
</script>

<template>
  <AppLabel
    :width="$attrs.width"
    :height="$attrs.height"
    :offset-top.sync="newOffsetTop"
    class="app-create-file"
    @create="$emit('create')"
  >
    <input
      v-show="false"
      v-if="!isSelf"
      slot="file"
      ref="input"
      :id="inputID"
      type="file"
      @input="fileChoose"
    >

    <!-- eslint-disable-next-line -->
    <slot slot="placeholder" name="placeholder" />
  </AppLabel>
</template>

<style lang="postcss">
.app-create-file {

}
</style>
